import { BrowserRouter } from 'react-router-dom'
import { MotionConfig } from 'framer-motion'
import { LanguageRouter } from '@/components/LanguageRouter'

export default function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <LanguageRouter />
      </BrowserRouter>
    </MotionConfig>
  )
}
